/* ==========================================================================
   Contact Form
   ========================================================================== */

// ...

const columns = () => [...document.querySelectorAll(".form-animation")];

const condenseLabels = () => {
  const targetColumns = () => {
    const columnnHasLabel = (column: Element) =>
      column.querySelector(".gfield_label") !== null;

    return columns().filter(columnnHasLabel);
  };

  const initColumn = (column: Element) => {
    const input = (column: Element) => column.querySelector(".large, .small");

    const setCondensed = (column: Element, condensed: boolean) => {
      column.classList.toggle("is-condensed", condensed);
      column.classList.toggle("is-not-condensed", !condensed);
    };

    input(column)?.addEventListener("focus", () => setCondensed(column, true));
    input(column)?.addEventListener("blur", (event) => {
      if (
        (event.target instanceof HTMLInputElement && !event.target.value) ||
        (event.target instanceof HTMLInputElement &&
          event.target.type === "tel" &&
          event.target.value === "(___) ___-____") ||
        (event.target instanceof HTMLSelectElement && !event.target.value)
      ) {
        setCondensed(column, false);
      }
    });
    window.addEventListener("load", () => {
      column.querySelectorAll("input").forEach((e) => {
        if (e.value) {
          setCondensed(column, true);
        }
      });
    });
  };

  targetColumns().forEach(initColumn);
};

condenseLabels();
